// utils/aws-s3.js
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { v4 as uuidv4 } from "uuid";

const s3Client = new S3Client({
    region: import.meta.env.VITE_AWS_REGION,
    credentials: {
        accessKeyId: import.meta.env.VITE_ACCESS_KEY_ID,
        secretAccessKey: import.meta.env.VITE_SECRETE_ACCESS_KEY,
    },
    // Add these browser-specific configurations
    forcePathStyle: false,
    endpoint: `https://s3.${import.meta.env.VITE_AWS_REGION}.amazonaws.com`,
});

export const uploadFileToS3 = async (file) => {
    try {
        const fileName = `eub/${uuidv4()}/${file.name}`;

        // Convert File to ArrayBuffer for better browser compatibility
        const arrayBuffer = await file.arrayBuffer();

        const command = new PutObjectCommand({
            Bucket: import.meta.env.VITE_S3_BUCKET,
            Key: fileName,
            Body: new Uint8Array(arrayBuffer), // Use Uint8Array instead of File directly
            ContentType: file.type,
            ContentLength: file.size,
            ACL: 'public-read',
        });

        const result = await s3Client.send(command);

        // Fix the return URL (you had undefined variables)
        return `https://${import.meta.env.VITE_S3_BUCKET}.s3.${import.meta.env.VITE_AWS_REGION}.amazonaws.com/${fileName}`;
        
    } catch (error) {
        console.error("S3 Upload Error:", error);
        throw new Error(`Failed to upload file: ${error.message}`);
    }
};